import { useState } from "react";
import api from "../api/api";

export default function Meetings() {
  const [meetings, setMeetings] = useState([]);

  const [form, setForm] = useState({
    meeting_id: "",
    contact_id: "",
    purpose: "",
    schedule_at: "",
    meeting_with: "",
  });

  // LOAD
  const load = async () => {
    try {
      const res = await api.get("/meeting");
      setMeetings(res.data || []);
    } catch (err) {
      console.log(err);
      alert("Error loading data");
    }
  };

  // CREATE
  const create = async () => {
    const {
      meeting_id,
      contact_id,
      purpose,
      schedule_at,
      meeting_with,
    } = form;

    if (
      !meeting_id ||
      !contact_id ||
      !purpose ||
      !schedule_at ||
      !meeting_with
    ) {
      return alert("All fields are mandatory");
    }

    try {
      await api.post("/meeting", {
        meeting_id,
        contact_id,
        purpose,
        schedule_at,
        meeting_with,
        status: "Pending",
      });

      alert("Meeting Created");

      // RESET FORM
      setForm({
        meeting_id: "",
        contact_id: "",
        purpose: "",
        schedule_at: "",
        meeting_with: "",
      });

      load();
    } catch (err) {
      console.log(err);
      alert("Error creating meeting");
    }
  };

  // UPDATE STATUS
  const updateStatus = async (id, status) => {
    try {
      await api.put(`/meeting/${id}`, {  // ✅ FIXED API
        status,
      });

      const updated = meetings.map((item) =>
        item.meeting_id === id
          ? { ...item, status, tempStatus: undefined }
          : item
      );

      setMeetings(updated);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="min-h-screen -mt-10">
      <h2 className="text-4xl font-semibold text-[#030244] text-center mb-8">
        Meetings
      </h2>

      {/* FORM */}
      <div className="max-w-lg mx-auto bg-white shadow-lg p-8 rounded-xl border">
        <div className="flex flex-col gap-4">
          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Meeting ID"
            value={form.meeting_id}
            onChange={(e) =>
              setForm({ ...form, meeting_id: e.target.value })
            }
          />

          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Contact ID"
            value={form.contact_id}
            onChange={(e) =>
              setForm({ ...form, contact_id: e.target.value })
            }
          />

          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Purpose"
            value={form.purpose}
            onChange={(e) =>
              setForm({ ...form, purpose: e.target.value })
            }
          />

          <input
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            placeholder="Meeting Person’s Email ID"
            value={form.meeting_with}
            onChange={(e) =>
              setForm({ ...form, meeting_with: e.target.value })
            }
          />

          <input
            type="datetime-local"
            className="border p-2 rounded focus:outline-none focus:ring-1 focus:ring-gray-500"
            value={form.schedule_at}
            onChange={(e) =>
              setForm({ ...form, schedule_at: e.target.value })
            }
          />
        </div>

        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={create}
            className="bg-[#030244] hover:bg-[#040261] text-white px-6 py-2 rounded text-lg"
          >
            Create
          </button>

          <button
            onClick={load}
            className="bg-green-700 hover:bg-green-600 text-white px-6 py-2 rounded text-lg"
          >
            Load
          </button>
        </div>
      </div>

      {/* TABLE */}
      <div className="w-full max-w-5xl mx-auto bg-white shadow mt-12 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[950px]">
            <thead className="bg-[#030244] text-white text-xl">
              <tr>
                <th className="p-3 text-center border font-medium">Meeting ID</th>
                <th className="p-3 text-center border font-medium">Contact ID</th>
                <th className="p-3 text-center border font-medium">Purpose</th>
                <th className="p-3 text-center border font-medium">Meeting With</th> {/* ✅ NEW */}
                <th className="p-3 text-center border font-medium">Schedule</th>
                <th className="p-3 text-center border font-medium">Status</th>
              </tr>
            </thead>

            <tbody>
              {meetings.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center p-4 text-xl">
                    No Data Found
                  </td>
                </tr>
              ) : (
                meetings.map((m) => (
                  <tr key={m.meeting_id} className="border-b text-lg">
                    <td className="p-3 text-center border text-gray-700">{m.meeting_id}</td>
                    <td className="p-3 border text-center text-gray-700">
                      {m.contact_id}
                    </td>
                    <td className="p-3 border text-center text-gray-700">
                      {m.purpose}
                    </td>

                    {/* ✅ NEW COLUMN */}
                    <td className="p-3 border text-center text-gray-700">
                      <a
                        href={`mailto:${m.meeting_with}`}
                        className="text-blue-600 underline"
                      >
                        {m.meeting_with}
                      </a>
                    </td>

                    <td className="p-3 border text-center text-gray-700">
                      {new Date(m.schedule_at).toLocaleString()}
                    </td>

                    {/* STATUS */}
                    <td className="p-3 border text-gray-700">
                      <div className="flex gap-2 items-center justify-center">
                        {m.status === "Completed" ||
                        m.status === "Cancelled" ? (
                          <span
                            className={`px-2 py-1 rounded text-white ${
                              m.status === "Completed"
                                ? "bg-green-700"
                                : "bg-red-600"
                            }`}
                          >
                            {m.status}
                          </span>
                        ) : (
                          <>
                            <select
                              value={m.tempStatus || m.status}
                              onChange={(e) => {
                                const updated = meetings.map((item) =>
                                  item.meeting_id === m.meeting_id
                                    ? {
                                        ...item,
                                        tempStatus: e.target.value,
                                      }
                                    : item
                                );
                                setMeetings(updated);
                              }}
                              className="border p-1 rounded text-gray-700"
                            >
                              <option value="Pending">Pending</option>
                              <option value="Completed">Completed</option>
                              <option value="Cancelled">Cancelled</option>
                            </select>

                            <button
                              onClick={() =>
                                updateStatus(
                                  m.meeting_id,
                                  m.tempStatus || m.status
                                )
                              }
                              className="bg-[#030244] text-white px-2 py-1 rounded text-md"
                            >
                              Save
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}